










import Vue from 'vue';
import Component from 'vue-class-component';
@Component({
    props: [
        'name',
        'currentValue',
        'value',
        'label'
    ],
    computed: {
        radioValue: {
            get (): string { return this.$props.currentValue },
            set (): void { this.$emit('change', this.$props.value) }
        },
    }
})
export default class RadioBox extends Vue {}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/radiobox.vue